"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6050],{

/***/ 30797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VO": function() { return /* reexport */ ShareProject_ShareProject; },
  "ze": function() { return /* reexport */ ShareState; }
});

// UNUSED EXPORTS: ShareIcons

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./src/@next/components/organisms/Overlay/index.ts + 2 modules
var Overlay = __webpack_require__(98720);
// EXTERNAL MODULE: ./src/@next/components/molecules/CardHeader/CardHeader.tsx
var CardHeader = __webpack_require__(37786);
// EXTERNAL MODULE: ./src/@sdk/hook/useWishlist.ts
var useWishlist = __webpack_require__(9212);
// EXTERNAL MODULE: ./src/@sdk/providers/utils.ts
var utils = __webpack_require__(60120);
// EXTERNAL MODULE: ./src/images/contact-form-icon.svg
var contact_form_icon = __webpack_require__(98777);
;// CONCATENATED MODULE: ./src/images/save-icon.svg
var save_icon_namespaceObject = __webpack_require__.p + "static/images/save-icon.svg";
;// CONCATENATED MODULE: ./src/images/save-initial.svg
var save_initial_namespaceObject = __webpack_require__.p + "static/images/save-initial.svg";
;// CONCATENATED MODULE: ./src/images/save-success-icon.svg
var save_success_icon_namespaceObject = __webpack_require__.p + "static/images/save-success-icon.svg";
;// CONCATENATED MODULE: ./src/images/share-icon.svg
var share_icon_namespaceObject = __webpack_require__.p + "static/images/share-icon.svg";
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/@next/utils/regions.ts + 1 modules
var regions = __webpack_require__(8044);
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
// EXTERNAL MODULE: ./src/@next/components/atoms/ErrorMessage/index.ts + 2 modules
var ErrorMessage = __webpack_require__(98615);
// EXTERNAL MODULE: ./src/@next/components/molecules/TextField/index.ts + 2 modules
var TextField = __webpack_require__(80648);
// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedHooks.tsx + 1 modules
var generatedHooks = __webpack_require__(73134);
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
// EXTERNAL MODULE: ./src/@next/components/overlays/ShareProject/styles.ts
var styles = __webpack_require__(45533);
;// CONCATENATED MODULE: ./src/@next/components/overlays/ShareProject/SaveProjectForm.tsx














function SaveProjectForm(param) {
    var onSuccess = param.onSuccess, productId = param.productId, selectedProductAttributes = param.selectedProductAttributes, productUrl = param.productUrl, variantId = param.variantId;
    var ref;
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var locale = (ref = router.query.locale) === null || ref === void 0 ? void 0 : ref.toString();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,generatedHooks/* useAddWishlistProductVariantMutation */.eK)(), 2), addWishlistProductVariantMutation = ref1[0], ref2 = ref1[1], loading = ref2.loading, error = ref2.error, data = ref2.data;
    var ref3 = (0,index_esm/* useForm */.cI)(), control = ref3.control, _formState = ref3.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, handleSubmit = ref3.handleSubmit;
    var handleOnSubmit = function(values) {
        var // @analitics
        ref;
        addWishlistProductVariantMutation({
            variables: (0,_object_spread/* default */.Z)({
                email: values.email,
                productAttributes: selectedProductAttributes,
                variantId: variantId
            }, (0,regions/* localeToSaleorQuery */.KK)(locale))
        });
        window === null || window === void 0 ? void 0 : (ref = window.rudderanalytics) === null || ref === void 0 ? void 0 : ref.track("Product Shared", {
            product_id: productId,
            recipient: values.email,
            share_via: "EMAIL",
            url: productUrl,
            variant: variantId
        });
    };
    (0,react.useEffect)(function() {
        if (!loading && !error && data) {
            var ref;
            var hasErrors = data === null || data === void 0 ? void 0 : (ref = data.wishlistAddVariant) === null || ref === void 0 ? void 0 : ref.wishlistErrors.length;
            if (!hasErrors && onSuccess) {
                onSuccess();
            }
        }
    }, [
        loading,
        error,
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(handleOnSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "form-error",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                    errors: error && [
                        {
                            field: "email",
                            message: error.message
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                name: "email",
                control: control,
                rules: {
                    pattern: {
                        message: intl.formatMessage(src_intl/* validationCommonMsg.invalidEmail */.a4.invalidEmail),
                        value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                    },
                    required: intl.formatMessage(src_intl/* validationCommonMsg.required */.a4.required)
                },
                render: function(param) {
                    var field = param.field;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* TextField */.n, (0,_object_spread/* default */.Z)({
                        label: intl.formatMessage(src_intl/* commonMessages.shortEmail */.i4.shortEmail),
                        autoComplete: "email",
                        errors: errors.email ? [
                            {
                                message: errors.email.message
                            }
                        ] : undefined
                    }, field));
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SaveButton */.k$, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    size: "lg",
                    fullWidth: true,
                    type: "submit",
                    disabled: isSubmitting,
                    children: isSubmitting ? intl.formatMessage(src_intl/* commonMessages.loading */.i4.loading) : intl.formatMessage(src_intl/* commonMessages.saveProject */.i4.saveProject)
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/@next/components/atoms/Loader/index.ts + 2 modules
var Loader = __webpack_require__(35582);
// EXTERNAL MODULE: ./src/@sdk/hook/useUser.ts
var useUser = __webpack_require__(7006);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
;// CONCATENATED MODULE: ./src/images/envelope.svg
var envelope_namespaceObject = __webpack_require__.p + "static/images/envelope.svg";
;// CONCATENATED MODULE: ./src/images/heart_red.svg
var heart_red_namespaceObject = __webpack_require__.p + "static/images/heart_red.svg";
// EXTERNAL MODULE: ./src/images/share.svg
var share = __webpack_require__(90385);
;// CONCATENATED MODULE: ./src/images/subcategories.svg
var subcategories_namespaceObject = __webpack_require__.p + "static/images/subcategories.svg";
// EXTERNAL MODULE: ./src/@next/components/atoms/Message/index.ts + 2 modules
var Message = __webpack_require__(92058);
;// CONCATENATED MODULE: ./src/@next/components/overlays/ShareProject/AddToWishlist.tsx














function AddToWishlist(param) {
    var addedToWishlist = param.addedToWishlist, variantId = param.variantId, selectedProductAttributes = param.selectedProductAttributes, children = param.children, _showMessage = param.showMessage, showMessage = _showMessage === void 0 ? false : _showMessage, productId = param.productId;
    var ref;
    var items = (0,useWishlist/* useWishlist */.E)().items;
    var intl = (0,useIntl/* default */.Z)();
    var user = (0,useUser/* useUser */.a)().user;
    var router = (0,next_router.useRouter)();
    var locale = (ref = router.query.locale) === null || ref === void 0 ? void 0 : ref.toString();
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showAddMessage = ref1[0], setShowAddMessage = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showRemoveMessage = ref2[0], setShowRemoveMessage = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showNotLoggedMessage = ref3[0], setShowNotLoggedMessage = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), error = ref5[0], setError = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,generatedHooks/* useAddWishlistProductVariantMutation */.eK)(), 1), addWishlistProductVariantMutation = ref6[0];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,generatedHooks/* useRemoveWishlistProductVariantMutation */.rp)(), 1), removeWishlistProductVariantMutation = ref7[0];
    var addOrRemoveFromWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, data, ref2, item, ref3, // @ analytics
            ref4, data1, ref5;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!user) {
                            setShowNotLoggedMessage(true);
                            return [
                                2
                            ];
                        }
                        setLoading(true);
                        if (!addedToWishlist) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            removeWishlistProductVariantMutation({
                                variables: (0,_object_spread/* default */.Z)({
                                    email: "",
                                    productAttributes: selectedProductAttributes,
                                    variantId: variantId
                                }, (0,regions/* localeToSaleorQuery */.KK)(locale))
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : (ref = data.wishlistRemoveVariant) === null || ref === void 0 ? void 0 : ref.errors.length) {
                            ;
                            setError(data === null || data === void 0 ? void 0 : (ref2 = data.wishlistRemoveVariant) === null || ref2 === void 0 ? void 0 : ref2.errors);
                        }
                        // setShowAddMessage(false);
                        setShowRemoveMessage(true);
                        item = items === null || items === void 0 ? void 0 : items.find(function(o) {
                            return o.variant.id === variantId && (0,utils/* compareAttributes */.o)(o.productAttributes, selectedProductAttributes);
                        });
                        window === null || window === void 0 ? void 0 : (ref1 = window.rudderanalytics) === null || ref1 === void 0 ? void 0 : ref1.track("Product Removed from Wishlist", {
                            name: item.variant.product.productType.slug,
                            product_id: item.variant.product.slug,
                            variant: variantId
                        });
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            addWishlistProductVariantMutation({
                                variables: (0,_object_spread/* default */.Z)({
                                    email: "",
                                    productAttributes: selectedProductAttributes,
                                    variantId: variantId
                                }, (0,regions/* localeToSaleorQuery */.KK)(locale))
                            })
                        ];
                    case 3:
                        data1 = _state.sent().data;
                        if (data1 === null || data1 === void 0 ? void 0 : (ref3 = data1.wishlistAddVariant) === null || ref3 === void 0 ? void 0 : ref3.errors.length) {
                            ;
                            setError(data1 === null || data1 === void 0 ? void 0 : (ref5 = data1.wishlistAddVariant) === null || ref5 === void 0 ? void 0 : ref5.errors);
                        }
                        // setShowRemoveMessage(false);
                        setShowAddMessage(true);
                        window === null || window === void 0 ? void 0 : (ref4 = window.rudderanalytics) === null || ref4 === void 0 ? void 0 : ref4.track("Product Added to Wishlist", {
                            product_id: productId,
                            variant: variantId
                        });
                        _state.label = 4;
                    case 4:
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function addOrRemoveFromWishlist() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRemoveMessageClose = function() {
        setShowRemoveMessage(false);
    };
    var handleAddMessageClose = function() {
        setShowAddMessage(false);
    };
    var handleNotLoggedMessageClose = function() {
        setShowNotLoggedMessage(false);
    };
    var getRemoveMessage = function() {
        return !error.length ? intl.formatMessage({
            defaultMessage: "Product removed from wishlist",
            id: "vUDG7n"
        }) : intl.formatMessage({
            defaultMessage: "Error while removing product from wishlist",
            id: "W6OcAx"
        });
    };
    var getAddMessage = function() {
        return !error.length ? intl.formatMessage({
            defaultMessage: "Product added to wishlist",
            id: "FqHbF7"
        }) : intl.formatMessage({
            defaultMessage: "Error while adding product to wishlist",
            id: "4ibWgQ"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children({
                added: addedToWishlist,
                loading: loading,
                onClick: addOrRemoveFromWishlist
            }),
            showMessage && showAddMessage && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* Message */.v, {
                title: getAddMessage(),
                status: error.length ? "error" : "success",
                onClick: handleAddMessageClose
            }),
            showMessage && showRemoveMessage && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* Message */.v, {
                title: getRemoveMessage(),
                status: error.length ? "error" : "success",
                onClick: handleRemoveMessageClose
            }),
            showMessage && showNotLoggedMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* Message */.v, {
                title: intl.formatMessage({
                    defaultMessage: "Please log in to add the product to your wish list",
                    id: "zMA2Wt"
                }),
                status: "error",
                onClick: handleNotLoggedMessageClose
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/@next/components/overlays/ShareProject/types.ts
var ShareState;
(function(ShareState) {
    ShareState["initial"] = "initial";
    ShareState["save"] = "save";
    ShareState["saveSuccess"] = "save-success";
    ShareState["share"] = "share";
    ShareState["addToWishlist"] = "add-to-wishlist";
    ShareState["removeToWishlist"] = "remove-to-wishlist";
})(ShareState || (ShareState = {}));

;// CONCATENATED MODULE: ./src/@next/components/overlays/ShareProject/SaveSelect.tsx
/* eslint-disable no-nested-ternary */ 















function SaveSelect(param) {
    var productId = param.productId, selectOption = param.selectOption, selectedProductAttributes = param.selectedProductAttributes, variantId = param.variantId, addedToWishlist = param.addedToWishlist;
    var intl = (0,useIntl/* default */.Z)();
    var user = (0,useUser/* useUser */.a)().user;
    var addOrRemoveToWishlistHandler = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(onClick) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onClick()
                        ];
                    case 1:
                        _state.sent();
                        if (addedToWishlist) {
                            selectOption(ShareState.removeToWishlist);
                        } else {
                            selectOption(ShareState.addToWishlist);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(onClick) {
            return _ref.apply(this, arguments);
        };
    }(), [
        selectOption
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* SaveSelect */.Om, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                className: "save-select__btn",
                font: "base",
                onClick: function() {
                    return selectOption(ShareState.save);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SaveSelectIcon */.RG, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: envelope_namespaceObject,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SaveSelectText */.P$, {
                        children: intl.formatMessage({
                            defaultMessage: "Send to email",
                            id: "W2Y8Ay"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SaveSelectIcon */.RG, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "arrow",
                            src: subcategories_namespaceObject,
                            alt: "arrow-icon"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                className: "save-select__btn",
                font: "base",
                onClick: function() {
                    return selectOption(ShareState.share);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SaveSelectIcon */.RG, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: share,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SaveSelectText */.P$, {
                        children: intl.formatMessage({
                            defaultMessage: "Share to social networks",
                            id: "bhq3iV"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SaveSelectIcon */.RG, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "arrow",
                            src: subcategories_namespaceObject,
                            alt: "arrow-icon"
                        })
                    })
                ]
            }),
            user && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToWishlist, {
                productId: productId,
                variantId: variantId,
                selectedProductAttributes: selectedProductAttributes,
                addedToWishlist: addedToWishlist,
                children: function(param) {
                    var onClick = param.onClick, loading = param.loading;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                        className: (0,clsx/* clsx */.W)("save-select__btn", {
                            "save-select__btn--loading": loading
                        }),
                        font: "base",
                        onClick: function() {
                            addOrRemoveToWishlistHandler(onClick);
                        },
                        disabled: loading,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SaveSelectIcon */.RG, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: heart_red_namespaceObject,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SaveSelectText */.P$, {
                                children: addedToWishlist ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: intl.formatMessage({
                                        defaultMessage: "Remove from wishlist",
                                        id: "6HOS3i"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: intl.formatMessage({
                                        defaultMessage: "Save to wishlist",
                                        id: "Xo3t9z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SaveSelectIcon */.RG, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "arrow",
                                    src: subcategories_namespaceObject,
                                    alt: "arrow-icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SaveSelectLoader */.dg, {
                                loading: loading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {})
                            })
                        ]
                    });
                }
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/@next/components/overlays/ShareProject/ShareIcons.tsx
var ShareIcons = __webpack_require__(16416);
;// CONCATENATED MODULE: ./src/@next/components/overlays/ShareProject/ShareProject.tsx




















var transformProductName = function(name) {
    var n = name.split("-").join(" ");
    return "".concat(n[0].toUpperCase()).concat(n.slice(1));
};
function ShareProjectSelect(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveSelect, (0,_object_spread/* default */.Z)({}, props));
}
function ShareProjectForm(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveProjectForm, (0,_object_spread/* default */.Z)({}, props));
}
function ShareProjectSuccessIcons(props) {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: intl.formatMessage({
                    defaultMessage: "Share your design with your friends and get their opinion:",
                    id: "9hDjZq"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareIcons/* ShareIcons */.S, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
}
function ShareProjectIcons(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareIcons/* ShareIcons */.S, (0,_object_spread/* default */.Z)({}, props));
}
function ShareProjectAddedToWishlist() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ContentWishlist */.ws, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: intl.formatMessage({
                defaultMessage: "We will keep you design safe.",
                id: "WDiiAE"
            })
        })
    });
}
function ShareProjectRemovedToWishlist() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ContentWishlist */.ws, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: intl.formatMessage({
                defaultMessage: "You creation is lost foreever.",
                id: "kS0mq9"
            })
        })
    });
}
var ShareProject = function(param) {
    var initialState = param.initialState, productCategory = param.productCategory, variantId = param.variantId, productId = param.productId, productImage = param.productImage, productName = param.productName, productUrl = param.productUrl, selectedProductAttributes = param.selectedProductAttributes;
    var intl = (0,useIntl/* default */.Z)();
    var modal = (0,esm/* useModal */.dd)();
    var ref = (0,react.useState)(initialState || ShareState.initial), state = ref[0], setState = ref[1];
    var selectOption = function(newState) {
        setState(newState);
    };
    var isShowLeft = [
        ShareState.initial,
        ShareState.save,
        ShareState.saveSuccess,
        ShareState.share,
        ShareState.addToWishlist,
        ShareState.removeToWishlist, 
    ].includes(state);
    var items = (0,useWishlist/* useWishlist */.E)().items;
    var addedToWishlist = (items === null || items === void 0 ? void 0 : items.some(function(param) {
        var variant = param.variant, productAttributes = param.productAttributes;
        if ((variant === null || variant === void 0 ? void 0 : variant.id) !== variantId) {
            return false;
        }
        return (0,utils/* compareAttributes */.o)(productAttributes, selectedProductAttributes);
    })) || false;
    var _obj;
    var FIXTURES = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ShareState.initial, {
        content: ShareProjectSelect,
        image: save_initial_namespaceObject,
        text: "",
        title: intl.formatMessage({
            defaultMessage: "Save for later your doors:",
            id: "IeC4nn"
        })
    }), (0,_define_property/* default */.Z)(_obj, ShareState.save, {
        content: ShareProjectForm,
        image: save_icon_namespaceObject,
        text: intl.formatMessage({
            defaultMessage: "It deserves to be saved and sent to your inbox.",
            id: "4HGt+A"
        }),
        title: intl.formatMessage({
            defaultMessage: "Your design is aDOORable!",
            id: "Q6TDFU"
        })
    }), (0,_define_property/* default */.Z)(_obj, ShareState.saveSuccess, {
        content: ShareProjectSuccessIcons,
        image: save_success_icon_namespaceObject,
        text: intl.formatMessage({
            defaultMessage: "You can easily watch it later. You can open it when you want on any device you would be using.",
            id: "f0J+wF"
        }),
        title: intl.formatMessage({
            defaultMessage: "The link to your project was sent to your email",
            id: "Ai+JIH"
        })
    }), (0,_define_property/* default */.Z)(_obj, ShareState.share, {
        content: ShareProjectIcons,
        image: contact_form_icon,
        text: intl.formatMessage({
            defaultMessage: "Share designs with your friends. Let’s see what they think!",
            id: "VcLJvj"
        }),
        title: intl.formatMessage({
            defaultMessage: "What do your family and relatives really think? Just ask.",
            id: "GdKD/W"
        })
    }), (0,_define_property/* default */.Z)(_obj, ShareState.addToWishlist, {
        content: ShareProjectAddedToWishlist,
        image: share_icon_namespaceObject,
        text: "",
        title: intl.formatMessage({
            defaultMessage: "Save for later",
            id: "U/jWmk"
        })
    }), (0,_define_property/* default */.Z)(_obj, ShareState.removeToWishlist, {
        content: ShareProjectRemovedToWishlist,
        image: share_icon_namespaceObject,
        text: "",
        title: intl.formatMessage({
            defaultMessage: "Save for later",
            id: "U/jWmk"
        })
    }), _obj);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        position: "fit",
        show: modal.visible,
        hide: modal.remove,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Modal */.u_, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Wrapper */.im, {
                children: [
                    isShowLeft && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Left */.dv, {
                        children: [
                            productImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ProductImage */.qN, {
                                src: productImage,
                                alt: "icon"
                            }),
                            productCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ProductCategory */.Pp, {
                                children: productCategory
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ProductTitle */.tc, {
                                children: transformProductName(productName)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Right */.O6, {
                        fullWidth: !isShowLeft,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Header */.h4, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* CardHeader */.O, {
                                    divider: true,
                                    formImage: FIXTURES[state].image,
                                    onHide: modal.remove,
                                    children: FIXTURES[state].title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Content */.VY, {
                                children: [
                                    FIXTURES[state].text && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                                        children: FIXTURES[state].text
                                    }),
                                    FIXTURES[state].content({
                                        addedToWishlist: addedToWishlist,
                                        onSuccess: function() {
                                            if (state === ShareState.save) {
                                                setState(ShareState.saveSuccess);
                                            }
                                        },
                                        productId: productId,
                                        productImage: productImage,
                                        selectOption: selectOption,
                                        selectedProductAttributes: selectedProductAttributes,
                                        productUrl: productUrl,
                                        variantId: variantId
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ShareProject_ShareProject = (esm/* default.create */.ZP.create(ShareProject));

;// CONCATENATED MODULE: ./src/@next/components/overlays/ShareProject/index.tsx





/***/ }),

/***/ 6986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* reexport */ SliceColorSample; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceColorSample/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 75px 0;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 50px 0;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 100px 0;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 25px;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 15px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  text-align: center;\n  margin-bottom: 35px;\n  ",
        "\n  ",
        "\n  &:before {\n    content: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 40px;\n    max-width: 650px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 30px;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 880px;\n  text-align: center;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  line-height: 1.6em;\n  text-align: center;\n  margin: 0 auto 63px;\n  opacity: 0.8;\n  ",
        "\n  ",
        "\n  * {\n    font: inherit;\n    line-height: inherit;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 60px;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 40px;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 36px;\n      height: 36px;\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 24px;\n      height: 24px;\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-bottom: 75px;\n  ",
        "\n  ",
        "\n  .color-sample__colors-item {\n    width: 46px;\n    height: 46px;\n    border-radius: 50%;\n    margin: 0 3px;\n    text-indent: -99999px;\n    transition: box-shadow 0.4s;\n    &:hover,\n    &.active {\n      box-shadow: inset 0 0 0 4px rgba(#fff, 0.3);\n    }\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}



var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject2(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject1()));
var Header = globalStyles/* styled.div */.zo.div(_templateObject5(), utils/* pageTitle */.tj, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject3()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject4()));
var Description = globalStyles/* styled.div */.zo.div(_templateObject8(), function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject6()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject7()));
var Colors = globalStyles/* styled.div */.zo.div(_templateObject13(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject9()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject10()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject11()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject12()));
var Link = globalStyles/* styled.div */.zo.div(_templateObject14());

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceColorSample/SliceColorSample.tsx







function SliceColorSample(param) {
    var _slice = param.slice, primary = _slice.primary, fields = _slice.fields, isMinimalist = param.context.isMinimalist;
    var ref = (0,react.useState)(""), activeColor = ref[0], setActiveColor = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "color-sample",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                children: primary.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                    field: primary.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Colors, {
                className: "color-sample__colors",
                children: fields && (fields === null || fields === void 0 ? void 0 : fields.map(function(c, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (0,clsx/* clsx */.W)("color-sample__colors-item", {
                            active: c.color === activeColor
                        }),
                        style: {
                            backgroundColor: c.color || ""
                        },
                        onClick: function() {
                            return setActiveColor(c.color);
                        },
                        children: c.color
                    }, i);
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                className: "color-sample__descr",
                children: primary.text && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                    field: primary.text
                })
            }),
            primary.cta_link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                className: "color-sample__link",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/collection/sample/10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            children: primary.cta_label
                        })
                    })
                })
            })
        ]
    });
}
SliceColorSample.componentName = "color_sample";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceColorSample/index.ts



/***/ }),

/***/ 60566:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/cart_white.svg";

/***/ }),

/***/ 98777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/contact-form-icon.svg";

/***/ }),

/***/ 90385:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/share.svg";

/***/ })

}]);